import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateEmojiMutation = createMutationHook(MembershipsCreatorApiClient.createEmoji, {
  mutationKey: ['createEmoji'],
})
